import React from 'react'
import Div from '../Div'

export default function TextWidget({logoSrc, logoAlt, text, width, height}) {
  return (
    <Div className="cs-text_widget">
      <img src={logoSrc} alt={logoAlt} width={width} height={height} />
      <p>{text}</p>
    </Div>
  )
}
